import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Table, Label } from 'semantic-ui-react'
import get from 'lodash/get'
import size from 'lodash/size'
import pickBy from 'lodash/pickBy'

import utils from '../../../../utils'

import CustomerCell from './CustomerCell'
import MerchantCell from './MerchantCell'
import ItemsCell from './ItemsCell'
import PaymentCell from './PaymentCell'
import OrderAtCell from './OrderAtCell'
import DriverCell from './DriverCell'
import ActionsCell from './ActionsCell'

import MerchantActions from '../../../../reducers/restaurantReducer'

class OrderListItem extends PureComponent {
  state = { remainingRtp: null }

  componentDidMount() {
    const { order, getMerchantNote, merchantsNote, isReadyToPickupEnabled } = this.props
    const merchantKey = order.restaurant.key

    const orderIsRtp = get(order, 'item_preparation_status', false)

    if (!merchantsNote[merchantKey]) {
      getMerchantNote(merchantKey)
    }

    if (isReadyToPickupEnabled) {
      if (['drivers_not_available', 'confirmed'].includes(order.status) && orderIsRtp !== 'ready_to_pickup') {
        this.calculateReadyToPickUp()
      } else if (orderIsRtp === 'ready_to_pickup') {
        this.enableAssignDriver()
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { order, timeSlot, onOpenRefundModal, saveRefundTo, lastEditedOrder } = this.props
    const { payment_gateway: paymentGateway, order_id: orderId } = order

    const nextOrderIsRtp = get(order, 'item_preparation_status', false)
    const oldOrderIsRtp = get(prevProps.order, 'item_preparation_status', false)
    const nextSubTotal = get(order, 'sub_total', 0)
    const oldSubTotal = get(prevProps.order, 'sub_total', 0)
    const nextPromotionDiscount = get(order, 'promotion_discount', 0)
    const oldPromotionDiscount = get(prevProps.order, 'promotion_discount', 0)
    const isLastEditedOrderChange = lastEditedOrder && (lastEditedOrder.order_id === orderId)
    const isSubTotalChange = nextSubTotal !== oldSubTotal
    const isPromotionDiscountChange = nextPromotionDiscount !== oldPromotionDiscount

    if (
      (((size(timeSlot) > 0 && prevProps.timeSlot !== timeSlot) ||
        (prevProps.order.status === 'pending' && order.status === 'confirmed')) &&
        nextOrderIsRtp !== 'ready_to_pickup') ||
      ((!oldOrderIsRtp && typeof nextOrderIsRtp === 'number') || oldOrderIsRtp !== nextOrderIsRtp)
    ) {
      this.calculateReadyToPickUp()
    }

    if (
      (!oldOrderIsRtp && nextOrderIsRtp === 'ready_to_pickup') ||
      (typeof oldOrderIsRtp === 'number' && nextOrderIsRtp === 'ready_to_pickup')
    ) {
      this.enableAssignDriver()
    }

    if(isLastEditedOrderChange && paymentGateway && (isSubTotalChange || isPromotionDiscountChange)) {
      const orderSummary = utils.order.getOrderSummary(order)
      const { customerGrandTotal } = orderSummary
      const amount = customerGrandTotal - paymentGateway.amount

      if (amount < 0) {
        onOpenRefundModal()
      } else {
        setTimeout(() => {
          saveRefundTo(order, null, null)
        }, 0)
      }
    }
  }

  enableAssignDriver = () => {
    this.setState({ remainingRtp: 0 })
    clearInterval(this.readyToPickUpCountdown)
  }

  calculateReadyToPickUp = () => {
    const { order, timeSlot } = this.props

    if (size(timeSlot) > 0) {
      const remainingRtp = utils.driver.calculateReadyToPickUp(order, timeSlot)

      this.setState({ remainingRtp }, this.countdownReadyToPickUp)
    }
  }

  countdownReadyToPickUp = () => {
    clearInterval(this.readyToPickUpCountdown)

    this.readyToPickUpCountdown = setInterval(() => {
      const { remainingRtp } = this.state

      if (remainingRtp > 0) {
        this.setState({ remainingRtp: remainingRtp - 1 })
      } else {
        this.setState({ remainingRtp: 0 })
        clearInterval(this.readyToPickUpCountdown)
      }
    }, 1000 * 60)
  }

  renderNoticeColor = () => {
    const { remainingRtp } = this.state
    const { order, readOnly } = this.props
    const isDriverAssigned = get(order, 'deliverer', null)

    if (order.support_needed || order.restaurant_need_support) {
      return { backgroundColor: 'lemonchiffon' }
    }

    if (
      ['confirmed', 'drivers_not_available'].includes(order.status) &&
      remainingRtp !== null &&
      remainingRtp <= 0 &&
      !isDriverAssigned &&
      !readOnly
    ) {
      return { backgroundColor: '#DAFFCB' }
    }

    return {}
  }

  render() {
    const {
      order,
      readOnly,
      operator,
      operators,
      merchantsNote,
      inProgressOrders,
      showModalPackage,
      showCancelReasons,
      showEditNote,
      showReserve,
      showManualAssign,
      showOrderMap,
      showMerchantMapWithDrivers,
      delivererInProgressOrders,
      driversGroupByPackage,
      showLiveTracking,
      showSwitchDriver,
      showEditItems,
      region,
      readyToPickUp,
    } = this.props

    const { remainingRtp } = this.state

    const merchantKey = order.restaurant.key
    const merchantNote = merchantsNote[merchantKey] || ''

    const color = this.renderNoticeColor()

    const isBlacklist = order.blacklist && order.blacklist.is_blacklist
    const isAnonymous = !order.tel
    const negative = isBlacklist || isAnonymous ? { negative: true } : {}

    return (
      <React.Fragment key={order.key}>
        <Table.Row style={color} {...negative}>
          <CustomerCell
            order={order}
            inProgressOrders={inProgressOrders}
            showOrderMap={showOrderMap}
            readOnly={readOnly}
          />

          <MerchantCell
            order={order}
            showMerchantMapWithDrivers={showMerchantMapWithDrivers}
            readOnly={readOnly}
          />

          <ItemsCell order={order} showEditItems={showEditItems} readOnly={readOnly} />

          <PaymentCell order={order} showEditNote={showEditNote} readOnly={readOnly} />

          <DriverCell
            order={order}
            driversGroupByPackage={driversGroupByPackage}
            delivererInProgressOrders={delivererInProgressOrders || []}
            showReserve={showReserve}
            showManualAssign={showManualAssign}
            showLiveTracking={showLiveTracking}
            showSwitchDriver={showSwitchDriver}
            readOnly={readOnly}
            remainingRtp={remainingRtp}
            readyToPickUp={readyToPickUp}
          />

          <OrderAtCell order={order} readOnly={readOnly} />

          <ActionsCell
            order={order}
            operator={operator}
            region={region}
            operators={operators}
            showModalPackage={showModalPackage}
            showCancelReasons={showCancelReasons}
            readOnly={readOnly}
            readyToPickUp={readyToPickUp}
          />
        </Table.Row>
        {merchantNote.length > 0 && (
          <Table.Row key={`${order.key}-merchant-note`}>
            <Table.Cell colSpan={8} textAlign="center">
              <Label>{merchantNote}</Label>
            </Table.Cell>
          </Table.Row>
        )}
      </React.Fragment>
    )
  }
}

const mapState = ({ auth, restaurants, users, drivers }) => ({
  operator: auth.data,
  timeSlot: drivers.timeSlot,
  readyToPickUp: drivers.readyToPickUp,
  merchantsNote: restaurants.merchantsNote,
  isReadyToPickupEnabled: drivers.readyToPickUp,
  operators: pickBy(users.data, user => user.role === 'operator@role'),
})

const mapDispatch = {
  getMerchantNote: MerchantActions.getMerchantNote,
}

export default connect(
  mapState,
  mapDispatch
)(OrderListItem)



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/index.js